import { combineReducers } from 'redux';

import * as reducers from './index';

export default combineReducers(reducers);
